var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-up",class:{ 'scroll-up--active': _vm.isActive },on:{"click":_vm.scrollToTop}},[_c('div',{staticClass:"scroll-up__arrow"})])}
var staticRenderFns = []

export { render, staticRenderFns }